import {
  ADD_TRAINING,
  ADD_TRAINING_FAIL,
  ADD_TRAINING_SUCCESS,
  ASSIGN_TRAININGS,
  ASSIGN_TRAININGS_FAIL,
  ASSIGN_TRAININGS_SUCCESS,
  DELETE_TRAINING_LINK,
  DELETE_TRAINING_LINK_FAIL,
  DELETE_TRAINING_LINK_SUCCESS,
  GET_TRAININGS_LIST,
  GET_TRAININGS_LIST_FAIL,
  GET_TRAININGS_LIST_SUCCESS,
  UPDATE_TRAINING_LINK,
  UPDATE_TRAINING_LINK_FAIL,
  UPDATE_TRAINING_LINK_SUCCESS,
} from "./actionTypes";

export const assignTraining = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: ASSIGN_TRAININGS,
  payload: { data, onSuccess, onError },
});

export const assignTrainingSuccess = data => ({
  type: ASSIGN_TRAININGS_SUCCESS,
  payload: data,
});

export const assignTrainingFail = data => ({
  type: ASSIGN_TRAININGS_FAIL,
  payload: data,
});

export const addTraining = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: ADD_TRAINING,
  payload: { data, onSuccess, onError },
});

export const addTrainingSuccess = data => ({
  type: ADD_TRAINING_SUCCESS,
  payload: data,
});

export const addTrainingFail = data => ({
  type: ADD_TRAINING_FAIL,
  payload: data,
});

export const getTrainingList = (data = {}) => ({
  type: GET_TRAININGS_LIST,
  payload: data,
});

export const getTrainingListSuccess = data => ({
  type: GET_TRAININGS_LIST_SUCCESS,
  payload: data,
});

export const getTrainingListFail = data => ({
  type: GET_TRAININGS_LIST_FAIL,
  payload: data,
});

export const updateTraining = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: UPDATE_TRAINING_LINK,
  payload: { data, onSuccess, onError },
});

export const updateTrainingSuccess = data => ({
  type: UPDATE_TRAINING_LINK_SUCCESS,
  payload: data,
});

export const updateTrainingFail = data => ({
  type: UPDATE_TRAINING_LINK_FAIL,
  payload: data,
});

export const deleteTraining = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: DELETE_TRAINING_LINK,
  payload: { data, onSuccess, onError },
});

export const deleteTrainingSuccess = data => ({
  type: DELETE_TRAINING_LINK_SUCCESS,
  payload: data,
});

export const deleteTrainingFail = data => ({
  type: DELETE_TRAINING_LINK_FAIL,
  payload: data,
});
